import { useNavigate } from 'react-router-dom';

/**
 * Điều hướng cho VAMS_PC_007. [3]/[7] 戻る phải quay về VAMS_PC_004 và giữ nguyên
 * search condition + page hiện tại (analyzing-fe.md §2.3) — dùng navigate(-1) để tận dụng
 * lịch sử trình duyệt thay vì điều hướng cứng tới path cố định (giống pattern VAMS_PC_006).
 */
function useInventoryReportRouter() {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return {
    handler: {
      handleBack,
    },
  };
}

export default useInventoryReportRouter;
